<template>
  <div style="height: 100%; width: 100%;">
    <video ref="videoPlayer" class="video-js vjs-theme-city vjs-fill" :data-matomo-title="title"></video>
  </div>
</template>

<script>
import videojs from "video.js";
export default {
  name: "m2h-video-player",
  props: ['autoplay', 'controls', 'sources', 'source', 'poster', 'title'],
  data(){
    return {
      player: null,
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: [],
        poster: ''
      }
    }
  },
  async mounted() {
    await this.initOptions()
    this.player = videojs(this.$refs.videoPlayer, this.videoOptions, () => {
      this.player.log('onPlayerReady', this);
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  
  methods: {
    async initOptions(){
      this.videoOptions.autoplay = this.autoplay || false
      this.videoOptions.controls = this.controls || true
      this.videoOptions.poster = this.poster || ''
      if (this.sources){
        this.videoOptions.sources = this.sources
      }
      if (this.source){
        this.videoOptions.sources = [
          {
            src: this.source
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
</style>